import { CommonModule } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, HostListener, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxChange, MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { MatSelect, MatSelectChange, MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

import { GestionclientesService } from "../../clientes/gestionclientes.service";
import { Cliente } from "../../shared/model/ajustesUsuario/cliente.model";
import { ConsultaList } from "../../shared/model/core/ConsultaList.model";
import { Area } from "../../shared/model/empleado/area.model";
import { Empleado } from "../../shared/model/empleado/empleado.model";
import {
  EstadoIncidenciaHost,
  IncidenciaHost,
  IncidenciaHostComentario,
  IncidenciaHostComentarioArchivo,
  IncidenciaHostDetalle,
  IncidenciaHostHistorial,
  IncidenciaHostTipoServicio,
} from "../../shared/model/iso42001/incidencia-host.model";
import { AuthService } from "../../security/auth.service";
import { ColumnaTablero, TableroIncidenciasBase, crearColumnasTablero } from "../../shared/incidencias-iso/tablero-incidencias-base";
import {
  INCIDENCIA_HOST_COLUMNS,
  IncidenciaHostColumn,
  PRIORIDAD_HOST_OPTIONS,
  SEVERIDAD_HOST_OPTIONS,
} from "../incidencias-host.constants";
import { IncidenciasHostService } from "../incidencias-host.service";

type IncidenciaHostColumnState = ColumnaTablero<IncidenciaHostColumn, IncidenciaHost>;

@Component({
  selector: "app-gestion-incidencias-host",
  standalone: true,
  templateUrl: "./gestion-incidencias-host.component.html",
  styleUrls: ["./gestion-incidencias-host.component.css"],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
})
export class GestionIncidenciasHostComponent extends TableroIncidenciasBase<IncidenciaHostColumn, IncidenciaHost> implements OnInit {
  @ViewChild("hostFormDialog") hostFormDialog?: TemplateRef<unknown>;
  @ViewChild("hostDetailDialog") hostDetailDialog?: TemplateRef<unknown>;
  @ViewChildren(MatSelect) hostSelects?: QueryList<MatSelect>;
  @ViewChildren(MatDatepicker) hostDatepickers?: QueryList<MatDatepicker<Date>>;

  readonly prioridadOptions = PRIORIDAD_HOST_OPTIONS;
  readonly severidadOptions = SEVERIDAD_HOST_OPTIONS;
  readonly columns = crearColumnasTablero<IncidenciaHostColumn, IncidenciaHost>(INCIDENCIA_HOST_COLUMNS);

  tiposServicio: IncidenciaHostTipoServicio[] = [];
  clientes: Cliente[] = [];
  clientesFormulario: Cliente[] = [];
  clientesFiltro: Cliente[] = [];
  private readonly clientesPorPagina = 500;
  readonly busquedaClienteFormulario = new FormControl("");
  readonly busquedaClienteFiltro = new FormControl("");
  readonly busquedaAreaActividad = new FormControl("");
  readonly busquedaTrabajadorActividad = new FormControl("");
  readonly busquedaAreaCoordinador = new FormControl("");
  readonly busquedaCoordinador = new FormControl("");
  readonly clienteTodosValor = -1;
  responsables: Empleado[] = [];
  trabajadoresActividad: Empleado[] = [];
  areas: Area[] = [];
  form: IncidenciaHost = this.nuevaIncidencia();
  tipoServicioForm: IncidenciaHostTipoServicio = this.nuevoTipoServicio();
  detalleForm: IncidenciaHostDetalle = {};
  comentarioTransicion = "";
  archivosTransicion: File[] = [];
  nuevoComentarioPorDetalle: Record<number, string> = {};
  conTipoAdicionalPorDetalle: Record<number, boolean> = {};
  tipoAdicionalPorDetalle: Record<number, number | undefined> = {};
  archivosPorDetalle: Record<number, File[]> = {};
  detalles: IncidenciaHostDetalle[] = [];
  historial: IncidenciaHostHistorial[] = [];
  selected?: IncidenciaHost;
  catalogoOpen = false;
  formOpen = false;
  detailOpen = false;
  loadingDetalle = false;
  mensaje = "";
  exitoTemporal = "";
  errorEmergente = "";
  idUsuarioSesion?: number;
  formFechaInicioHora = "";
  formFechaInicioAtencionHora = "";
  formFechaFinHora = "";
  formFechaFueraServicioInicioHora = "";
  formFechaFueraServicioFinHora = "";
  fechaConfirmacionVobo?: Date;
  horaConfirmacionVobo = "";
  salidaServicioDialogOpen = false;
  salidaServicioFecha: Date = new Date();
  salidaServicioHora = "";
  actividadesOpen = false;
  actividadFormOpen = false;
  actividadEditando = false;
  comentariosDetalle?: IncidenciaHostDetalle;
  fueraServicioResumenOpen = false;
  actividadFecha: Date = new Date();
  actividadHora = "";
  transicionDialogOpen = false;
  transicionObjetivo?: EstadoIncidenciaHost;
  private formDialogRef?: MatDialogRef<unknown>;
  private detailDialogRef?: MatDialogRef<unknown>;
  private exitoTemporalTimer?: ReturnType<typeof setTimeout>;

  constructor(
    private readonly incidenciasService: IncidenciasHostService,
    private readonly clientesService: GestionclientesService,
    private readonly authService: AuthService,
    private readonly dialog: MatDialog,
  ) {
    super();
  }

  ngOnInit(): void {
    const session = this.authService.getCosData();
    this.idUsuarioSesion = session?.idUsuarioSession || session?.usuario?.id;
    this.cargarCatalogos();
    this.cargarClientes();
    this.busquedaClienteFormulario.valueChanges.subscribe((valor) => this.filtrarClientes("formulario", valor));
    this.busquedaClienteFiltro.valueChanges.subscribe((valor) => this.filtrarClientes("filtro", valor));
    this.refrescarTodas();
  }

  @HostListener("document:mousedown", ["$event"])
  onDocumentMouseDown(event: MouseEvent): void {
    if (this.hayDatepickerAbierto()) {
      const target = event.target as HTMLElement;
      if (!target.closest(".incidencia-host-datepicker-panel") && !target.closest(".incidencias-host-page__date-field")) {
        this.cerrarDatepickersHost();
      }
    }

    if (!this.haySelectAbierto()) {
      return;
    }
    const target = event.target as HTMLElement;
    if (target.closest(".incidencia-host-select-panel") || target.closest("mat-select, .mat-mdc-select")) {
      return;
    }
    this.cerrarSelectsHost();
  }

  @HostListener("document:keydown.escape", ["$event"])
  onDocumentEscape(event: KeyboardEvent): void {
    if (!this.detailOpen) {
      return;
    }
    event.preventDefault();
    this.cerrarPanel();
  }

  get mostrarFechaFinFormulario(): boolean {
    return Boolean(this.form.idIncidenciaHost && (
      this.form.fechaFin || this.form.estadoEvento === "ATENDIDO" || this.form.estadoEvento === "VOBO"
    ));
  }

  get mostrarFechaInicioAtencionFormulario(): boolean {
    return Boolean(this.form.idIncidenciaHost && this.form.estadoEvento !== "ABIERTO");
  }

  get soloLectura(): boolean {
    return this.selected?.estadoEvento === "VOBO" || this.form.estadoEvento === "VOBO";
  }

  get mostrarResumenFueraServicio(): boolean {
    return Boolean(this.form.fechaFueraServicioInicio);
  }

  get tiposReporteDisponibles(): IncidenciaHostTipoServicio[] {
    const clavesPermitidas = new Set(["VALORACION", "CONEXION", "SOFTWARE", "HARDWARE"]);
    return this.tiposServicio.filter((tipo) => clavesPermitidas.has((tipo.clave || "").toUpperCase()));
  }

  trackByIncidencia(_index: number, incidencia: IncidenciaHost): number {
    return incidencia.idIncidenciaHost || 0;
  }

  trackByDetalle(_index: number, detalle: IncidenciaHostDetalle): number {
    return detalle.idDetalleHost || 0;
  }

  trackByComentario(_index: number, comentario: IncidenciaHostComentario): number {
    return comentario.idComentarioHost || 0;
  }

  trackByTipo(_index: number, tipo: IncidenciaHostTipoServicio): number {
    return tipo.idTipoServicioHost || 0;
  }

  cargarCatalogos(): void {
    this.incidenciasService.catalogos().subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        this.tiposServicio = res.tiposServicio || [];
        this.responsables = res.responsables || [];
        this.trabajadoresActividad = res.trabajadoresActividad || [];
        this.areas = res.areas || [];
        this.aplicarTipoInicial();
      },
      error: (e) => this.mostrarError(e, "No fue posible cargar catálogos Host."),
    });
  }

  cargarClientes(): void {
    this.cargarPaginaClientes(0, []);
  }

  /**
   * Recupera todas las páginas de clientes para que la opción "Todos" del alta
   * represente el catálogo completo disponible para la sesión.
   */
  private cargarPaginaClientes(regInicial: number, acumulados: Cliente[]): void {
    const request = new ConsultaList<Cliente>();
    request.regInicial = regInicial;
    request.regXPagina = this.clientesPorPagina;
    this.clientesService.filtroBusquedaCliente(request).subscribe({
      next: (res) => {
        const pagina = res?.list || [];
        const clientesCargados = [...acumulados, ...pagina];
        const totalClientes = res?.pTotalItems;
        if (pagina.length > 0 && typeof totalClientes === "number" && clientesCargados.length < totalClientes) {
          this.cargarPaginaClientes(regInicial + pagina.length, clientesCargados);
          return;
        }
        this.clientes = clientesCargados;
        this.clientesFormulario = [...clientesCargados];
        this.clientesFiltro = [...clientesCargados];
      },
      error: (e) => this.mostrarError(e, "No fue posible cargar clientes para Incidencias Hosting."),
    });
  }

  onClientesFormularioChange(ids: Array<number | null> | null): void {
    if ((ids || []).includes(this.clienteTodosValor)) {
      this.form.idsClientes = this.clientes.map((cliente) => cliente.id);
      return;
    }
    this.form.idsClientes = (ids || []).filter((id): id is number => typeof id === "number" && id > 0);
  }

  onClientesFiltroChange(ids: Array<number | null> | null): void {
    if ((ids || []).includes(this.clienteTodosValor)) {
      this.filtros.idsClientes = undefined;
      return;
    }
    this.filtros.idsClientes = (ids || []).filter((id): id is number => typeof id === "number" && id > 0);
  }

  actualizarFechaComentario(comentario: IncidenciaHostComentario, valor: string): void {
    const fecha = this.fechaLocal(valor);
    comentario.fechaModificacion = fecha ? this.formatearFechaHoraLocal(fecha) : valor;
  }

  iniciarEdicionComentario(comentario: IncidenciaHostComentario, detalle: IncidenciaHostDetalle): void {
    // Los comentarios históricos no tenían asignación propia; se muestran con la de su actividad
    // como punto de partida, sin alterar la actividad hasta que se guarde el comentario.
    if (comentario.idArea == null) {
      comentario.idArea = detalle.idArea;
      comentario.area = detalle.area;
    }
    if (comentario.idEmpleadoResponsable == null) {
      comentario.idEmpleadoResponsable = detalle.idEmpleadoResponsable;
      comentario.idUsuarioResponsable = detalle.idUsuarioResponsable;
      comentario.responsable = detalle.responsable;
    }
    comentario.conTipoAdicional = comentario.idTipoServicioAdicional != null;
    comentario.editando = true;
  }

  /** El tipo adicional solo se registra en el comentario; no cambia el tipo de reporte del ticket. */
  faltaTipoAdicionalNuevo(detalle: IncidenciaHostDetalle): boolean {
    const id = detalle.idDetalleHost || 0;
    return Boolean(this.conTipoAdicionalPorDetalle[id]) && !this.tipoAdicionalPorDetalle[id];
  }

  faltaTipoAdicionalEdicion(comentario: IncidenciaHostComentario): boolean {
    return Boolean(comentario.conTipoAdicional) && !comentario.idTipoServicioAdicional;
  }

  areaComentario(comentario: IncidenciaHostComentario, detalle?: IncidenciaHostDetalle): string {
    return comentario.area || detalle?.area || "Sin área";
  }

  responsableComentario(comentario: IncidenciaHostComentario, detalle?: IncidenciaHostDetalle): string {
    return comentario.responsable || detalle?.responsable || "Sin responsable";
  }

  textoClientes(incidencia: IncidenciaHost = this.form): string {
    const nombres = incidencia.clientes?.map((cliente) => cliente.razonSocial).filter(Boolean) || [];
    if (nombres.length) {
      return nombres.join(", ");
    }
    const ids = incidencia.idsClientes || [];
    return ids.map((id) => this.clientes.find((cliente) => cliente.id === id)?.razonsocial || String(id)).join(", ");
  }

  tituloTarjeta(incidencia: IncidenciaHost): string {
    const proyectosAfectados = incidencia.clientes?.map((cliente) => cliente.razonSocial).filter(Boolean) || [];
    // La tarjeta conserva legibilidad al resumir únicamente hasta tres proyectos afectados.
    if (proyectosAfectados.length > 3) {
      return "Falla diversos productos";
    }
    return proyectosAfectados.join(", ") || "Sin proyecto afectado";
  }

  clienteBloqueado(): boolean {
    return Boolean(this.form.idIncidenciaHost);
  }

  consultarColumna(column: IncidenciaHostColumnState): void {
    column.loading = true;
    const filtro = { ...this.filtros, estadoEvento: column.estado };
    const regInicial = (column.currentPage - 1) * this.itemsPerPage;
    this.incidenciasService.consultarKanban(filtro, regInicial, this.itemsPerPage).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        column.items = res.incidencias || [];
        column.totalItems = res.totalItems || 0;
        column.totalPages = Math.ceil(column.totalItems / this.itemsPerPage);
      },
      error: (e) => this.mostrarError(e, "No fue posible consultar Incidencias Hosting."),
      complete: () => {
        column.loading = false;
      },
    });
  }

  cambiarPagina(column: IncidenciaHostColumnState, delta: number): void {
    const next = column.currentPage + delta;
    if (next < 1 || (column.totalPages && next > column.totalPages)) {
      return;
    }
    column.currentPage = next;
    this.consultarColumna(column);
  }

  cerrarSelectSiAbierto(event: MouseEvent, select: MatSelect): void {
    if (!select.panelOpen) {
      this.cerrarSelectsHost(select);
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    select.close();
  }

  /**
   * En selección múltiple, confirmar una opción también confirma el panel.
   * El diferimiento conserva primero la actualización de ngModel de Material.
   */
  cerrarClienteDespuesDeSeleccionar(select: MatSelect, _event: MatSelectChange): void {
    setTimeout(() => select.close(), 0);
  }

  toggleDatepicker(datepicker: MatDatepicker<Date>, event?: MouseEvent): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (datepicker.opened) {
      datepicker.close();
      return;
    }
    datepicker.open();
  }

  abrirNueva(): void {
    this.selected = undefined;
    this.form = this.nuevaIncidencia();
    this.prepararHorasFormulario(this.form);
    this.detalles = [];
    this.historial = [];
    this.detalleForm = {};
    this.comentarioTransicion = "";
    this.archivosTransicion = [];
    this.busquedaAreaCoordinador.setValue("", { emitEvent: false });
    this.busquedaCoordinador.setValue("", { emitEvent: false });
    this.cerrarModalesSecundarios();
    this.formOpen = true;
    this.detailOpen = false;
    this.mensaje = "";
    this.abrirModalFormulario();
  }

  cerrarPanel(): void {
    this.formOpen = false;
    this.detailOpen = false;
    this.selected = undefined;
    this.form = this.nuevaIncidencia();
    this.detalles = [];
    this.historial = [];
    this.detalleForm = {};
    this.comentarioTransicion = "";
    this.archivosTransicion = [];
    this.cerrarModalesSecundarios();
    this.detailDialogRef?.close();
    this.detailDialogRef = undefined;
    this.formDialogRef?.close();
    this.formDialogRef = undefined;
    this.refrescarTodas();
  }

  cerrarFormulario(): void {
    this.formOpen = false;
    this.formDialogRef?.close();
    this.formDialogRef = undefined;
    if (!this.selected) {
      this.form = this.nuevaIncidencia();
      this.prepararHorasFormulario(this.form);
    }
    this.refrescarTodas();
  }

  /** idDetalleComentarios reabre Actividades y los comentarios de esa actividad tras recargar (p. ej. al comentar con adjuntos). */
  seleccionar(incidencia: IncidenciaHost, idDetalleComentarios?: number): void {
    if (!incidencia.idIncidenciaHost) {
      return;
    }
    this.loadingDetalle = true;
    this.incidenciasService.obtener(incidencia.idIncidenciaHost).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        this.selected = res.incidencia || incidencia;
        this.form = this.clonarIncidencia(this.selected);
        this.prepararHorasFormulario(this.form);
        this.detalles = this.mapearComentarios(res.detalles || [], res.comentarios || []);
        this.historial = res.historial || [];
        this.detalleForm = { idIncidenciaHost: this.selected.idIncidenciaHost };
        this.comentarioTransicion = "";
        this.archivosTransicion = [];
        this.cerrarModalesSecundarios();
        this.formOpen = false;
        this.detailOpen = true;
        this.abrirModalSeguimiento();
        if (idDetalleComentarios) {
          this.actividadesOpen = true;
          this.comentariosDetalle = this.detalles.find((detalle) => detalle.idDetalleHost === idDetalleComentarios);
        }
      },
      error: (e) => this.mostrarError(e, "No fue posible abrir la incidencia Hosting."),
      complete: () => {
        this.loadingDetalle = false;
      },
    });
  }

  editarSeleccionada(): void {
    if (!this.selected) {
      return;
    }
    this.form = this.clonarIncidencia(this.selected);
    this.prepararHorasFormulario(this.form);
    this.formOpen = true;
    this.detailOpen = false;
    this.detailDialogRef?.close();
    this.detailDialogRef = undefined;
    this.abrirModalFormulario();
  }

  guardarIncidencia(): void {
    if (this.soloLectura) {
      this.mostrarError(null, "La incidencia cerrada no permite cambios.");
      return;
    }
    this.mensaje = "";
    this.prepararResponsableActual();
    this.prepararFechasParaGuardar();
    if (!this.form.idTipoServicio) {
      this.mostrarError(null, "No está configurada la clave VALORACIÓN para Incidencias Hosting.");
      return;
    }
    if (!this.form.idsClientes?.length) {
      this.mostrarError(null, "Selecciona al menos un cliente afectado.");
      return;
    }
    if (!this.form.idIncidenciaHost && (!this.form.idAreaResponsable || !this.form.idEmpleadoResponsable
      || !this.form.idUsuarioResponsable || !this.form.responsable)) {
      this.mostrarError(null, "Selecciona el área responsable y responsable Host.");
      return;
    }
    if (!this.form.fechaInicio) {
      this.mostrarError(null, "Captura una fecha y hora de inicio válida.");
      return;
    }
    if (this.form.estadoEvento !== "ABIERTO" && !this.form.fechaInicioAtencion) {
      this.mostrarError(null, "Captura una fecha y hora de inicio de atención válida.");
      return;
    }
    if (this.form.estadoEvento === "ATENDIDO" && !this.form.fechaFin) {
      this.mostrarError(null, "Captura una fecha y hora de fin válida.");
      return;
    }
    const request = this.form.idIncidenciaHost
      ? this.incidenciasService.actualizar(this.form)
      : this.incidenciasService.guardar(this.form);
    request.subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        this.mostrarExito("Incidencia Hosting guardada.");
        this.refrescarTodas();
        this.formDialogRef?.close();
        this.formDialogRef = undefined;
        this.formOpen = false;
        if (res.idGenerado) {
          this.incidenciasService.obtener(res.idGenerado).subscribe((detalle) => {
            if (detalle.incidencia) {
              this.seleccionar(detalle.incidencia);
            }
          });
        } else if (this.form.idIncidenciaHost) {
          this.seleccionar({ idIncidenciaHost: this.form.idIncidenciaHost });
        }
      },
      error: (e) => this.mostrarError(e, "No fue posible guardar la incidencia Hosting."),
    });
  }

  cambiarEstado(incidencia: IncidenciaHost, event?: Event): void {
    event?.stopPropagation();
    const siguiente = this.siguienteEstado(incidencia.estadoEvento);
    if (!incidencia.idIncidenciaHost || !siguiente) {
      return;
    }
    if (!this.selected || this.selected.idIncidenciaHost !== incidencia.idIncidenciaHost) {
      this.seleccionar(incidencia);
      return;
    }
    if (!this.validarTransicion(siguiente)) {
      return;
    }
    const cambios = this.prepararCambiosTransicion(siguiente);
    this.incidenciasService.cambiarEstado(incidencia.idIncidenciaHost, siguiente, cambios, this.comentarioParaTransicion()).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        const terminar = () => {
          this.comentarioTransicion = "";
          this.archivosTransicion = [];
          this.fechaConfirmacionVobo = undefined;
          this.horaConfirmacionVobo = "";
          this.transicionDialogOpen = false;
          this.transicionObjetivo = undefined;
          this.refrescarTodas();
          if (this.selected?.idIncidenciaHost === incidencia.idIncidenciaHost) {
            this.seleccionar(incidencia);
          }
        };
        if (siguiente === "VOBO" && res.idComentarioGenerado && this.archivosTransicion.length) {
          this.subirArchivos(res.idComentarioGenerado, this.archivosTransicion, terminar);
        } else {
          terminar();
        }
      },
      error: (e) => this.mostrarError(e, "No fue posible cambiar el estado."),
    });
  }

  regresarAProceso(): void {
    if (!this.selected?.idIncidenciaHost || this.selected.estadoEvento !== "ATENDIDO") {
      return;
    }
    if (!this.validarTransicion("PROCESO")) {
      return;
    }
    const cambios = this.prepararCambiosTransicion("PROCESO");
    this.incidenciasService.cambiarEstado(this.selected.idIncidenciaHost, "PROCESO", cambios, this.comentarioTransicion.trim()).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        this.comentarioTransicion = "";
        this.transicionDialogOpen = false;
        this.transicionObjetivo = undefined;
        this.refrescarTodas();
        this.seleccionar({ idIncidenciaHost: this.selected?.idIncidenciaHost });
      },
      error: (e) => this.mostrarError(e, "No fue posible regresar la incidencia a proceso."),
    });
  }

  guardarTipoServicio(): void {
    this.tipoServicioForm.clave = (this.tipoServicioForm.clave || "").toUpperCase();
    this.incidenciasService.guardarTipoServicio(this.tipoServicioForm).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        this.tiposServicio = res.tiposServicio || [];
        this.tipoServicioForm = this.nuevoTipoServicio();
        this.mostrarExito("Tipo de servicio guardado.");
      },
      error: (e) => this.mostrarError(e, "No fue posible guardar el tipo de servicio."),
    });
  }

  editarTipoServicio(tipo: IncidenciaHostTipoServicio): void {
    this.tipoServicioForm = { ...tipo };
    this.catalogoOpen = true;
  }

  guardarDetalle(): void {
    if (!this.selected?.idIncidenciaHost || this.soloLectura) {
      return;
    }
    if (!this.detalleForm.actividad?.trim()) {
      this.avisarError("Captura la actividad realizada.");
      return;
    }
    const responsable = this.trabajadorActividadSeleccionado();
    const area = this.areas.find((item) => item.id === Number(this.detalleForm.idArea));
    if (!responsable || !area) {
      this.avisarError("Selecciona el área y el responsable de la actividad.");
      return;
    }
    this.detalleForm.idIncidenciaHost = this.selected.idIncidenciaHost;
    this.detalleForm.fechaActividad = this.combinarFechaHora(this.actividadFecha, this.actividadHora) || new Date();
    this.detalleForm.area = area?.area;
    this.detalleForm.responsable = this.nombreEmpleado(responsable);
    this.detalleForm.idUsuarioResponsable = responsable?.idUsuario || responsable?.usuario?.id;
    const editando = this.actividadEditando;
    this.incidenciasService.guardarDetalle(this.detalleForm).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        this.detalleForm = { idIncidenciaHost: this.selected?.idIncidenciaHost };
        this.actividadFormOpen = false;
        this.actividadEditando = false;
        this.mostrarExito(editando ? "Actividad actualizada." : "Actividad agregada.");
        this.seleccionar(this.selected);
      },
      error: (e) => this.mostrarError(e, editando ? "No fue posible actualizar la actividad." : "No fue posible guardar el detalle."),
    });
  }

  guardarComentario(detalle: IncidenciaHostDetalle): void {
    if (!this.selected?.idIncidenciaHost || !detalle.idDetalleHost || this.soloLectura) {
      return;
    }
    const comentario = (this.nuevoComentarioPorDetalle[detalle.idDetalleHost] || "").trim();
    if (!comentario || this.faltaTipoAdicionalNuevo(detalle)) {
      return;
    }
    const idTipoServicioAdicional = this.conTipoAdicionalPorDetalle[detalle.idDetalleHost]
      ? this.tipoAdicionalPorDetalle[detalle.idDetalleHost]
      : undefined;
    const req: IncidenciaHostComentario = {
      idDetalleHost: detalle.idDetalleHost,
      idIncidenciaHost: this.selected.idIncidenciaHost,
      idArea: detalle.idArea,
      area: detalle.area,
      idEmpleadoResponsable: detalle.idEmpleadoResponsable,
      idUsuarioResponsable: detalle.idUsuarioResponsable,
      responsable: detalle.responsable,
      idTipoServicioAdicional,
      comentario,
      fechaModificacion: this.formatearFechaHoraLocal(new Date()),
    };
    this.incidenciasService.guardarComentario(req).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        const archivos = this.archivosPorDetalle[detalle.idDetalleHost || 0] || [];
        if (res.idComentarioGenerado && archivos.length) {
          this.subirArchivos(res.idComentarioGenerado, archivos, () => this.seleccionar(this.selected!, detalle.idDetalleHost));
        } else {
          this.seleccionar(this.selected!, detalle.idDetalleHost);
        }
        this.nuevoComentarioPorDetalle[detalle.idDetalleHost || 0] = "";
        this.conTipoAdicionalPorDetalle[detalle.idDetalleHost || 0] = false;
        this.tipoAdicionalPorDetalle[detalle.idDetalleHost || 0] = undefined;
        this.archivosPorDetalle[detalle.idDetalleHost || 0] = [];
      },
      error: (e) => this.mostrarError(e, "No fue posible guardar el comentario."),
    });
  }

  actualizarComentario(comentario: IncidenciaHostComentario): void {
    if (this.soloLectura || this.faltaTipoAdicionalEdicion(comentario)) {
      return;
    }
    // Desmarcar la casilla limpia el tipo adicional guardado.
    const req: IncidenciaHostComentario = {
      ...comentario,
      idTipoServicioAdicional: comentario.conTipoAdicional ? comentario.idTipoServicioAdicional : undefined,
    };
    this.incidenciasService.actualizarComentario(req).subscribe({
      next: (res) => {
        if (this.tieneError(res)) {
          return;
        }
        comentario.editando = false;
        if (this.selected) {
          this.seleccionar(this.selected, comentario.idDetalleHost);
        }
      },
      error: (e) => this.mostrarError(e, "No fue posible actualizar el comentario."),
    });
  }

  onFiles(detalle: IncidenciaHostDetalle, event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!detalle.idDetalleHost || !input.files) {
      return;
    }
    this.archivosPorDetalle[detalle.idDetalleHost] = Array.from(input.files);
  }

  abrirArchivo(archivo: IncidenciaHostComentarioArchivo): void {
    if (!archivo.idArchivoHost) {
      return;
    }
    // La pestaña se abre en el mismo clic: abierta después de la descarga, el navegador la bloquea como emergente.
    const pestana = window.open("", "_blank");
    this.incidenciasService.descargarArchivo(archivo.idArchivoHost).subscribe({
      next: (blob) => {
        // El servidor responde octet-stream; con el tipo real el navegador muestra imágenes, PDF o video en vez de descargarlos.
        const url = window.URL.createObjectURL(new Blob([blob], { type: archivo.mimeType || blob.type || "application/octet-stream" }));
        if (pestana) {
          pestana.location.href = url;
        } else {
          const enlace = document.createElement("a");
          enlace.href = url;
          enlace.download = archivo.nombreArchivo || "archivo";
          enlace.click();
        }
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      },
      error: (e) => {
        pestana?.close();
        this.mostrarError(e, "No fue posible abrir el archivo adjunto.");
      },
    });
  }

  onFueraServicioChange(event?: MatCheckboxChange): void {
    if (this.form.fueraServicio) {
      this.abrirSalidaServicioDialog();
    } else {
      const fechaFin = new Date();
      this.form.fechaFueraServicioFin = fechaFin;
      this.formFechaFueraServicioFinHora = this.obtenerHora(fechaFin);
      this.form.tiempoFueraServicioMin = this.calcularMinutosEntre(this.form.fechaFueraServicioInicio, fechaFin);
    }
  }

  aceptarSalidaServicio(): void {
    const fecha = this.combinarFechaHora(this.salidaServicioFecha, this.salidaServicioHora);
    if (!fecha) {
      this.mostrarError(null, "Selecciona una fecha y hora válida para la salida de servicio.");
      return;
    }
    this.form.fueraServicio = true;
    this.form.prioridad = "Alta";
    this.form.severidad = "Critico";
    this.form.fechaFueraServicioInicio = fecha;
    this.form.fechaFueraServicioFin = undefined;
    this.formFechaFueraServicioInicioHora = this.obtenerHora(fecha);
    this.formFechaFueraServicioFinHora = "";
    this.form.tiempoFueraServicioMin = 0;
    this.salidaServicioDialogOpen = false;
  }

  cancelarSalidaServicio(): void {
    this.form.fueraServicio = false;
    this.form.fechaFueraServicioInicio = undefined;
    this.form.fechaFueraServicioFin = undefined;
    this.form.tiempoFueraServicioMin = undefined;
    this.salidaServicioDialogOpen = false;
    this.refrescarTodas();
  }

  onTipoServicioChange(): void {
    const tipo = this.tipoSeleccionado(this.form.idTipoServicio);
    this.form.tipoReporte = tipo?.clave;
    if (tipo?.clave === "HARDWARE") {
      this.form.requiereCambioHardware = true;
    }
  }

  onClaveServicioChange(value: string): void {
    this.tipoServicioForm.clave = (value || "").toUpperCase();
  }

  /** Mismo criterio que en actividades: al elegir coordinador, el área se toma de su puesto. */
  onResponsableActualChange(): void {
    this.prepararResponsableActual();
    const coordinador = this.responsables.find((item) => item.idEmpleado === Number(this.form.idEmpleadoResponsable));
    const idArea = this.idAreaDelTrabajador(coordinador);
    if (idArea) {
      this.form.idAreaResponsable = idArea;
      this.onAreaResponsableChange();
    }
  }

  /** Mismo criterio que en actividades: si el coordinador elegido no es del área, se limpia. */
  onAreaResponsableChange(): void {
    const area = this.areas.find((item) => item.id === Number(this.form.idAreaResponsable));
    this.form.areaResponsable = area?.area;
    const coordinador = this.responsables.find((item) => item.idEmpleado === Number(this.form.idEmpleadoResponsable));
    if (coordinador && this.idAreaDelTrabajador(coordinador) !== Number(this.form.idAreaResponsable)) {
      this.form.idEmpleadoResponsable = undefined;
      this.form.idUsuarioResponsable = undefined;
      this.form.responsable = undefined;
    }
  }

  onAreaActividadChange(): void {
    const responsable = this.trabajadorActividadSeleccionado();
    if (responsable && this.idAreaDelTrabajador(responsable) !== Number(this.detalleForm.idArea)) {
      this.detalleForm.idEmpleadoResponsable = undefined;
      this.detalleForm.idUsuarioResponsable = undefined;
      this.detalleForm.responsable = undefined;
    }
  }

  onTrabajadorActividadChange(): void {
    const responsable = this.trabajadorActividadSeleccionado();
    const idArea = responsable ? this.idAreaDelTrabajador(responsable) : undefined;
    if (idArea) {
      this.detalleForm.idArea = idArea;
    }
  }

  onArchivosTransicion(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.archivosTransicion = input.files ? Array.from(input.files) : [];
  }

  archivosDetalleLabel(detalle?: IncidenciaHostDetalle): string {
    const total = detalle?.idDetalleHost ? (this.archivosPorDetalle[detalle.idDetalleHost] || []).length : 0;
    if (!total) {
      return "No se eligió ningún archivo";
    }
    return total === 1 ? "1 archivo seleccionado" : `${total} archivos seleccionados`;
  }

  archivosTransicionLabel(): string {
    const total = this.archivosTransicion.length;
    if (!total) {
      return "No se eligió ningún archivo";
    }
    return total === 1 ? "1 archivo seleccionado" : `${total} archivos seleccionados`;
  }

  abrirActividades(): void {
    this.actividadesOpen = true;
    this.actividadFormOpen = false;
    this.comentariosDetalle = undefined;
  }

  cerrarActividades(): void {
    this.actividadesOpen = false;
    this.actividadFormOpen = false;
    this.comentariosDetalle = undefined;
    this.refrescarTodas();
  }

  abrirNuevaActividad(): void {
    const ahora = new Date();
    const responsableActual = this.trabajadoresActividad.find((item) => item.idEmpleado === Number(this.form.idEmpleadoResponsable))
      || this.trabajadoresActividad.find((item) => (item.usuario?.id || item.idUsuario) === this.idUsuarioSesion);
    this.actividadFecha = ahora;
    this.actividadHora = this.obtenerHora(ahora);
    this.detalleForm = {
      idIncidenciaHost: this.selected?.idIncidenciaHost,
      idArea: this.idAreaDelTrabajador(responsableActual) || this.form.idAreaResponsable,
      idEmpleadoResponsable: responsableActual?.idEmpleado || this.form.idEmpleadoResponsable,
      actividad: "",
    };
    this.actividadEditando = false;
    this.actividadFormOpen = true;
    this.comentariosDetalle = undefined;
  }

  /** Reutiliza el formulario de alta; al llevar idDetalleHost el backend actualiza en lugar de insertar. */
  abrirEditarActividad(detalle: IncidenciaHostDetalle): void {
    const fecha = this.fechaLocal(detalle.fechaActividad) || new Date();
    this.actividadFecha = fecha;
    this.actividadHora = this.obtenerHora(fecha);
    this.detalleForm = {
      idDetalleHost: detalle.idDetalleHost,
      idIncidenciaHost: this.selected?.idIncidenciaHost,
      idArea: detalle.idArea,
      idEmpleadoResponsable: detalle.idEmpleadoResponsable,
      actividad: detalle.actividad || "",
    };
    this.actividadEditando = true;
    this.actividadFormOpen = true;
    this.comentariosDetalle = undefined;
  }

  puedeEditarActividad(detalle: IncidenciaHostDetalle): boolean {
    return detalle.idUsuarioAlta != null && detalle.idUsuarioAlta === this.idUsuarioSesion;
  }

  cerrarNuevaActividad(): void {
    this.actividadEditando = false;
    this.actividadFormOpen = false;
    this.detalleForm = { idIncidenciaHost: this.selected?.idIncidenciaHost };
    this.busquedaAreaActividad.setValue("", { emitEvent: false });
    this.busquedaTrabajadorActividad.setValue("", { emitEvent: false });
    this.refrescarTodas();
  }

  verComentarios(detalle: IncidenciaHostDetalle): void {
    this.comentariosDetalle = detalle;
    this.actividadFormOpen = false;
  }

  cerrarComentarios(): void {
    this.comentariosDetalle = undefined;
    this.refrescarTodas();
  }

  abrirResumenFueraServicio(): void {
    if (!this.mostrarResumenFueraServicio) {
      return;
    }
    this.actividadesOpen = false;
    this.actividadFormOpen = false;
    this.comentariosDetalle = undefined;
    this.fueraServicioResumenOpen = true;
  }

  cerrarResumenFueraServicio(): void {
    this.fueraServicioResumenOpen = false;
    this.refrescarTodas();
  }

  guardarResumenFueraServicio(): void {
    this.fueraServicioResumenOpen = false;
    this.guardarIncidencia();
  }

  actividadesOrdenadas(): IncidenciaHostDetalle[] {
    return [...this.detalles].sort((a, b) => this.timestamp(b.fechaActividad) - this.timestamp(a.fechaActividad));
  }

  comentariosOrdenados(detalle?: IncidenciaHostDetalle): IncidenciaHostComentario[] {
    return [...(detalle?.comentarios || [])].sort((a, b) => this.timestamp(b.fechaModificacion) - this.timestamp(a.fechaModificacion));
  }

  detalleDelComentario(comentario: IncidenciaHostComentario): IncidenciaHostDetalle | undefined {
    return this.detalles.find((detalle) => detalle.idDetalleHost === comentario.idDetalleHost);
  }

  comentariosFueraServicio(): IncidenciaHostComentario[] {
    const inicio = this.timestamp(this.form.fechaFueraServicioInicio);
    const fin = this.timestamp(this.form.fechaFueraServicioFin) || (this.form.fueraServicio ? Date.now() : 0);
    if (!inicio || !fin) {
      return [];
    }
    return this.detalles
      .reduce((comentarios, detalle) => comentarios.concat(detalle.comentarios || []), [] as IncidenciaHostComentario[])
      .filter((comentario) => {
        const fechaComentario = this.timestamp(comentario.fechaModificacion);
        return fechaComentario >= inicio && fechaComentario <= fin;
      })
      .sort((a, b) => this.timestamp(a.fechaModificacion) - this.timestamp(b.fechaModificacion));
  }

  tiempoFueraServicioVisible(): string {
    const inicio = this.timestamp(this.form.fechaFueraServicioInicio);
    const fin = this.timestamp(this.form.fechaFueraServicioFin) || (this.form.fueraServicio ? Date.now() : 0);
    if (inicio && fin) {
      return this.minutosLabel(Math.max(0, Math.floor((fin - inicio) / 60000)));
    }
    return this.minutosLabel(this.form.tiempoFueraServicioMin);
  }

  abrirTransicionDialog(): void {
    if (!this.selected) {
      return;
    }
    const siguiente = this.siguienteEstado(this.selected.estadoEvento);
    if (!siguiente) {
      return;
    }
    this.comentarioTransicion = "";
    this.archivosTransicion = [];
    this.transicionObjetivo = siguiente;
    if (siguiente === "VOBO") {
      const ahora = new Date();
      this.fechaConfirmacionVobo = ahora;
      this.horaConfirmacionVobo = this.obtenerHora(ahora);
    } else {
      this.fechaConfirmacionVobo = undefined;
      this.horaConfirmacionVobo = "";
    }
    this.transicionDialogOpen = true;
  }

  abrirRegresoAProcesoDialog(): void {
    if (this.selected?.estadoEvento !== "ATENDIDO") {
      return;
    }
    this.comentarioTransicion = "";
    this.archivosTransicion = [];
    this.transicionObjetivo = "PROCESO";
    this.transicionDialogOpen = true;
  }

  cerrarTransicionDialog(): void {
    this.transicionDialogOpen = false;
    this.transicionObjetivo = undefined;
    this.comentarioTransicion = "";
    this.archivosTransicion = [];
    this.fechaConfirmacionVobo = undefined;
    this.horaConfirmacionVobo = "";
    this.refrescarTodas();
  }

  confirmarTransicion(): void {
    if (!this.selected) {
      return;
    }
    if (this.transicionObjetivo === "PROCESO" && this.selected.estadoEvento === "ATENDIDO") {
      this.regresarAProceso();
      return;
    }
    this.cambiarEstado(this.selected);
  }

  severidadDescripcion(valor?: string): string {
    return this.severidadOptions.find((option) => option.value === valor)?.description || "";
  }

  tipoSeleccionado(id?: number): IncidenciaHostTipoServicio | undefined {
    return this.tiposServicio.find((tipo) => tipo.idTipoServicioHost === Number(id));
  }

  etiquetaTipoReporte(clave?: string): string {
    const etiquetas: Record<string, string> = {
      VALORACION: "VALORACIÓN",
      CONEXION: "CONEXIÓN",
      SOFTWARE: "SOFTWARE",
      HARDWARE: "HARDWARE",
    };
    return etiquetas[(clave || "").toUpperCase()] || clave || "";
  }

  nombreEmpleado(empleado?: Empleado): string {
    if (!empleado) {
      return "";
    }
    const persona = empleado.persona;
    const nombrePersona = [persona?.nombre, persona?.apellidoPaterno, persona?.apellidoMaterno]
      .filter(Boolean)
      .join(" ")
      .trim();
    return nombrePersona || empleado.usuario?.nombrePersona || empleado.usuario?.user_nom || "";
  }

  siguienteEstado(estado?: EstadoIncidenciaHost): EstadoIncidenciaHost | undefined {
    if (estado === "ABIERTO") {
      return "PROCESO";
    }
    if (estado === "PROCESO") {
      return "ATENDIDO";
    }
    if (estado === "ATENDIDO") {
      return "VOBO";
    }
    return undefined;
  }

  labelEstadoSiguiente(estado?: EstadoIncidenciaHost): string {
    const siguiente = this.siguienteEstado(estado);
    return siguiente ? "Pasar a " + siguiente : "Cerrada";
  }

  estadoTitulo(estado?: EstadoIncidenciaHost): string {
    return this.columns.find((column) => column.estado === estado)?.titulo || estado || "Seguimiento";
  }

  estadoColor(estado?: EstadoIncidenciaHost): string {
    return this.columns.find((column) => column.estado === estado)?.color || "#c0181f";
  }

  estadoIcono(estado?: EstadoIncidenciaHost): string {
    return this.columns.find((column) => column.estado === estado)?.icon || "assignment";
  }

  puedeEditarComentario(comentario: IncidenciaHostComentario): boolean {
    return comentario.idUsuario === this.idUsuarioSesion || (
      this.selected?.estadoEvento === "VOBO" && this.selected?.idUsuarioAlta === this.idUsuarioSesion
    );
  }

  toDateTimeLocal(value?: string | Date): string {
    const date = this.fechaLocal(value);
    if (!date) {
      return String(value);
    }
    return this.formatearFechaHoraLocal(date).slice(0, 16);
  }

  minutosLabel(minutos?: number): string {
    if (minutos === null || minutos === undefined) {
      return "-";
    }
    const horas = Math.floor(minutos / 60);
    const mins = minutos % 60;
    return horas ? `${horas} h ${mins} min` : `${mins} min`;
  }

  getActiveFiltersCount(): number {
    return Object.values(this.filtros).filter((value) => Array.isArray(value) ? value.length > 0
      : value !== null && value !== undefined && value !== "").length;
  }

  override limpiarFiltros(): void {
    this.busquedaClienteFiltro.setValue("", { emitEvent: false });
    this.clientesFiltro = [...this.clientes];
    super.limpiarFiltros();
  }

  puedeEditarFlujo(): boolean {
    return Boolean(this.selected && this.selected.estadoEvento !== "VOBO");
  }

  tipoReporteBloqueado(): boolean {
    // El alta y el estado ABIERTO quedan fijos en VALORACIÓN; la clave se modifica solo en PROCESO o ATENDIDO.
    const editable = this.form.estadoEvento === "PROCESO" || this.form.estadoEvento === "ATENDIDO";
    return !this.form.idIncidenciaHost || !editable || this.soloLectura;
  }

  tipoReporteDetalleBloqueado(): boolean {
    return this.tipoReporteBloqueado();
  }

  private validarTransicion(siguiente: EstadoIncidenciaHost): boolean {
    this.errorCarga = "";
    this.errorEmergente = "";
    if (!this.comentarioTransicion.trim()) {
      this.avisarError("Captura un comentario para mover la incidencia.");
      return false;
    }
    if (siguiente === "PROCESO") {
		if (!this.form.fechaInicioAtencion || !this.formFechaInicioAtencionHora) {
			this.avisarError("Captura la fecha y hora de inicio de atención.");
			return false;
		}
		this.form.fechaInicioAtencion = this.combinarFechaHora(this.form.fechaInicioAtencion, this.formFechaInicioAtencionHora);
		if (!this.form.fechaInicioAtencion) {
			this.avisarError("Captura la fecha y hora de inicio de atención.");
			return false;
		}
    }
		if (siguiente === "ATENDIDO") {
			if (!this.form.fechaFin || !this.formFechaFinHora) {
				this.avisarError("Captura la fecha y hora de fin.");
				return false;
			}
			this.form.fechaFin = this.combinarFechaHora(this.form.fechaFin, this.formFechaFinHora);
			if (!this.form.fechaFin) {
				this.avisarError("Captura la fecha y hora de fin.");
				return false;
			}
    }
    if (siguiente === "VOBO") {
      if (!this.fechaConfirmacionVobo || !this.horaConfirmacionVobo) {
        this.avisarError("Captura la fecha y hora de confirmación de Vo.Bo.");
        return false;
      }
      if (!this.archivosTransicion.length) {
        this.avisarError("Adjunta una evidencia para cerrar con Vo.Bo.");
        return false;
      }
    }
    return true;
  }

  private prepararCambiosTransicion(_siguiente: EstadoIncidenciaHost): IncidenciaHost {
    this.prepararFechasParaGuardar();
    return {
      ...this.form,
      idIncidenciaHost: this.selected?.idIncidenciaHost,
    };
  }

  private comentarioParaTransicion(): string {
    const comentario = this.comentarioTransicion.trim();
    if (this.transicionObjetivo !== "VOBO") {
      return comentario;
    }
    const fechaConfirmacion = this.combinarFechaHora(this.fechaConfirmacionVobo, this.horaConfirmacionVobo);
    if (!fechaConfirmacion) {
      return comentario;
    }
    return `[Confirmación de Vo.Bo: ${this.formatearFechaHoraComentario(fechaConfirmacion)}]\n${comentario}`;
  }

  private formatearFechaHoraComentario(fecha: string | Date): string {
    const valor = this.fechaLocal(fecha);
    if (!valor) {
      return "";
    }
    const dia = String(valor.getDate()).padStart(2, "0");
    const mes = String(valor.getMonth() + 1).padStart(2, "0");
    const anio = valor.getFullYear();
    return `${dia}/${mes}/${anio} ${this.obtenerHora(valor)}`;
  }

  private prepararResponsableActual(): void {
    const responsable = this.responsables.find((item) => item.idEmpleado === Number(this.form.idEmpleadoResponsable));
    if (!responsable) {
      return;
    }
    this.form.idUsuarioResponsable = responsable.usuario?.id || responsable.idUsuario;
    this.form.responsable = this.nombreEmpleado(responsable);
  }

  get trabajadoresActividadFiltrados(): Empleado[] {
    const idArea = Number(this.detalleForm.idArea);
    const busqueda = this.normalizarBusqueda(this.busquedaTrabajadorActividad.value);
    return this.trabajadoresActividad.filter((trabajador) => {
      const coincideArea = !idArea || this.idAreaDelTrabajador(trabajador) === idArea;
      return coincideArea && this.normalizarBusqueda(this.nombreEmpleado(trabajador)).includes(busqueda);
    });
  }

  /** Coordinadores con perfil Host del área elegida, como el selector de responsable en actividades. */
  get coordinadoresFiltrados(): Empleado[] {
    // Una incidencia ya creada conserva su asignación aunque el coordinador haya cambiado de área.
    if (this.form.idIncidenciaHost) {
      return this.responsables;
    }
    const idArea = Number(this.form.idAreaResponsable);
    const busqueda = this.normalizarBusqueda(this.busquedaCoordinador.value);
    return this.responsables.filter((coordinador) => {
      const coincideArea = !idArea || this.idAreaDelTrabajador(coordinador) === idArea;
      return coincideArea && this.normalizarBusqueda(this.nombreEmpleado(coordinador)).includes(busqueda);
    });
  }

  get areasCoordinadorFiltradas(): Area[] {
    const busqueda = this.normalizarBusqueda(this.busquedaAreaCoordinador.value);
    return this.areas.filter((area) => this.normalizarBusqueda(area.area).includes(busqueda));
  }

  get areasActividadFiltradas(): Area[] {
    const busqueda = this.normalizarBusqueda(this.busquedaAreaActividad.value);
    return this.areas.filter((area) => this.normalizarBusqueda(area.area).includes(busqueda));
  }

  private trabajadorActividadSeleccionado(): Empleado | undefined {
    return this.trabajadoresActividad.find((item) => item.idEmpleado === Number(this.detalleForm.idEmpleadoResponsable));
  }

  private idAreaDelTrabajador(trabajador?: Empleado): number | undefined {
    const idArea = trabajador?.puesto?.id_area;
    return idArea ? Number(idArea) : undefined;
  }

  private normalizarBusqueda(valor?: string | null): string {
    return (valor || "").trim().toLocaleLowerCase();
  }

  private aplicarTipoInicial(): void {
    if (this.form.idTipoServicio || !this.tiposServicio.length) {
      return;
    }
    this.aplicarTipoDiagnostico();
  }

  private aplicarTipoDiagnostico(): void {
    const tipoInicial = this.obtenerTipoDiagnostico();
    if (!tipoInicial) {
      return;
    }
    this.form.idTipoServicio = tipoInicial.idTipoServicioHost;
    this.form.tipoReporte = tipoInicial.clave;
    if (tipoInicial.clave !== "HARDWARE") {
      this.form.requiereCambioHardware = false;
      this.form.equipoReemplazo = undefined;
    }
  }

  private obtenerTipoDiagnostico(): IncidenciaHostTipoServicio | undefined {
    const tiposServicio = this.tiposServicio || [];
    return tiposServicio.find((tipo) => (tipo.clave || "").toUpperCase() === "VALORACION");
  }

  private abrirSalidaServicioDialog(): void {
    const base = this.fechaLocal(this.form.fechaFueraServicioInicio) || new Date();
    const fecha = Number.isNaN(base.getTime()) ? new Date() : base;
    this.salidaServicioFecha = fecha;
    this.salidaServicioHora = this.obtenerHora(fecha) || this.obtenerHora(new Date());
    this.salidaServicioDialogOpen = true;
  }

  private calcularMinutosDesde(fecha: Date): number {
    return Math.max(0, Math.floor((new Date().getTime() - fecha.getTime()) / 60000));
  }

  private calcularMinutosEntre(inicio?: string | Date, fin?: string | Date): number {
    const inicioMs = this.timestamp(inicio);
    const finMs = this.timestamp(fin);
    return inicioMs && finMs ? Math.max(0, Math.floor((finMs - inicioMs) / 60000)) : 0;
  }

  private subirArchivos(idComentario: number, archivos: File[], done: () => void): void {
    let pendientes = archivos.length;
    archivos.forEach((archivo) => {
      const formData = new FormData();
      formData.append("file", archivo, "$" + idComentario + "$" + archivo.name);
      this.incidenciasService.uploadArchivo(formData).subscribe({
        next: (res) => this.tieneError(res),
        error: (e) => this.mostrarError(e, "No fue posible subir un archivo."),
        complete: () => {
          pendientes -= 1;
          if (pendientes === 0) {
            done();
          }
        },
      });
    });
  }

  private haySelectAbierto(): boolean {
    return Boolean(this.hostSelects?.some((select) => select.panelOpen));
  }

  private hayDatepickerAbierto(): boolean {
    return Boolean(this.hostDatepickers?.some((datepicker) => datepicker.opened));
  }

  private cerrarSelectsHost(excepto?: MatSelect): void {
    this.hostSelects?.forEach((select) => {
      if (select !== excepto && select.panelOpen) {
        select.close();
      }
    });
  }

  private cerrarDatepickersHost(): void {
    this.hostDatepickers?.forEach((datepicker) => {
      if (datepicker.opened) {
        datepicker.close();
      }
    });
  }

  private mapearComentarios(
    detalles: IncidenciaHostDetalle[],
    comentarios: IncidenciaHostComentario[],
  ): IncidenciaHostDetalle[] {
    return detalles.map((detalle) => ({
      ...detalle,
      comentarios: comentarios.filter((comentario) => comentario.idDetalleHost === detalle.idDetalleHost),
    }));
  }

  private abrirModalFormulario(): void {
    if (!this.hostFormDialog) {
      return;
    }
    this.formDialogRef?.close();
    this.formDialogRef = this.dialog.open(this.hostFormDialog, {
      disableClose: false,
      autoFocus: true,
      width: "80vw",
      maxWidth: "80vw",
      maxHeight: "68vh",
      panelClass: ["custom-modalbox", "incidencia-host-form-dialog"],
    });
    this.posicionarModalHost(this.formDialogRef);
    this.formDialogRef.afterClosed().subscribe(() => {
      this.formOpen = false;
      this.formDialogRef = undefined;
      this.refrescarTodas();
    });
  }

  private abrirModalSeguimiento(): void {
    if (!this.selected) {
      return;
    }
    this.detailDialogRef?.close();
    this.detailDialogRef = undefined;
    this.detailOpen = true;
  }

  private posicionarModalHost(ref: MatDialogRef<unknown>): void {
    ref.updateSize("80vw");
    ref.updatePosition();
  }

  private clonarIncidencia(incidencia: IncidenciaHost): IncidenciaHost {
    return {
      ...incidencia,
      idsClientes: [...(incidencia.idsClientes || [])],
      clientes: [...(incidencia.clientes || [])],
      fechaInicio: this.fechaLocal(incidencia.fechaInicio),
      fechaInicioAtencion: this.fechaLocal(incidencia.fechaInicioAtencion),
      fechaFin: this.fechaLocal(incidencia.fechaFin),
      fechaFueraServicioInicio: this.fechaLocal(incidencia.fechaFueraServicioInicio),
      fechaFueraServicioFin: this.fechaLocal(incidencia.fechaFueraServicioFin),
    };
  }

  private nuevaIncidencia(): IncidenciaHost {
    const ahora = new Date();
    const tipoInicial = this.obtenerTipoDiagnostico();
    return {
      estadoEvento: "ABIERTO",
      fechaInicio: ahora,
      prioridad: "Media",
      severidad: "Medio",
      fueraServicio: false,
      requiereCambioHardware: false,
      idsClientes: [],
      idTipoServicio: tipoInicial?.idTipoServicioHost,
      tipoReporte: tipoInicial?.clave,
    };
  }

  private prepararHorasFormulario(incidencia: IncidenciaHost): void {
    this.formFechaInicioHora = this.obtenerHora(incidencia.fechaInicio) || this.obtenerHora(new Date());
		this.formFechaInicioAtencionHora = this.obtenerHora(incidencia.fechaInicioAtencion);
    this.formFechaFinHora = this.obtenerHora(incidencia.fechaFin);
    this.formFechaFueraServicioInicioHora = this.obtenerHora(incidencia.fechaFueraServicioInicio);
    this.formFechaFueraServicioFinHora = this.obtenerHora(incidencia.fechaFueraServicioFin);
  }

  private prepararFechasParaGuardar(): void {
    this.form.fechaInicio = this.combinarFechaHora(this.form.fechaInicio, this.formFechaInicioHora);
		if (this.form.fechaInicioAtencion) {
			this.form.fechaInicioAtencion = this.combinarFechaHora(this.form.fechaInicioAtencion, this.formFechaInicioAtencionHora);
		}
    if (this.form.fechaFin) {
      this.form.fechaFin = this.combinarFechaHora(this.form.fechaFin, this.formFechaFinHora);
    }
    if (this.form.fechaFueraServicioInicio) {
      this.form.fechaFueraServicioInicio = this.combinarFechaHora(
        this.form.fechaFueraServicioInicio, this.formFechaFueraServicioInicioHora,
      );
    }
    if (this.form.fechaFueraServicioFin) {
      this.form.fechaFueraServicioFin = this.combinarFechaHora(
        this.form.fechaFueraServicioFin, this.formFechaFueraServicioFinHora,
      );
    }
  }

  private combinarFechaHora(fecha?: string | Date, hora?: string): string | undefined {
    const base = this.fechaLocal(fecha);
    if (!base) {
      return undefined;
    }
    const partes = (hora || "00:00").split(":");
    base.setHours(Number(partes[0] || 0), Number(partes[1] || 0), 0, 0);
    return this.formatearFechaHoraLocal(base);
  }

  private obtenerHora(value?: string | Date): string {
    const date = this.fechaLocal(value);
    if (!date) {
      return "";
    }
    return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  }

  private mostrarExito(mensaje: string): void {
    this.exitoTemporal = mensaje;
    this.errorEmergente = "";
    this.mensaje = "";
    if (this.exitoTemporalTimer) {
      clearTimeout(this.exitoTemporalTimer);
    }
    this.exitoTemporalTimer = setTimeout(() => {
      this.exitoTemporal = "";
      this.exitoTemporalTimer = undefined;
    }, 2200);
  }

  private cerrarModalesSecundarios(): void {
    this.actividadesOpen = false;
    this.actividadFormOpen = false;
    this.comentariosDetalle = undefined;
    this.fueraServicioResumenOpen = false;
    this.transicionDialogOpen = false;
    this.transicionObjetivo = undefined;
  }

  private timestamp(value?: string | Date): number {
    return this.fechaLocal(value)?.getTime() || 0;
  }

  /** Convierte fechas sin zona horaria como hora local para no desplazar el día al serializar. */
  private fechaLocal(value?: string | Date): Date | undefined {
    if (!value) {
      return undefined;
    }
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? undefined : new Date(value);
    }
    const partes = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(value);
    if (partes) {
      const fecha = new Date(
        Number(partes[1]), Number(partes[2]) - 1, Number(partes[3]),
        Number(partes[4] || 0), Number(partes[5] || 0), Number(partes[6] || 0), 0,
      );
      return Number.isNaN(fecha.getTime()) ? undefined : fecha;
    }
    const fecha = new Date(value);
    return Number.isNaN(fecha.getTime()) ? undefined : fecha;
  }

  private formatearFechaHoraLocal(fecha: Date): string {
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const dia = String(fecha.getDate()).padStart(2, "0");
    const hora = String(fecha.getHours()).padStart(2, "0");
    const minuto = String(fecha.getMinutes()).padStart(2, "0");
    const segundo = String(fecha.getSeconds()).padStart(2, "0");
    return `${anio}-${mes}-${dia}T${hora}:${minuto}:${segundo}`;
  }

  private filtrarClientes(destino: "formulario" | "filtro", valor: string | null): void {
    const busqueda = (valor || "").trim().toLocaleLowerCase();
    const coincidencias = !busqueda ? [...this.clientes] : this.clientes.filter((cliente) =>
      (cliente.razonsocial || "").toLocaleLowerCase().includes(busqueda),
    );
    if (destino === "formulario") {
      this.clientesFormulario = coincidencias;
      return;
    }
    this.clientesFiltro = coincidencias;
  }

  private nuevoTipoServicio(): IncidenciaHostTipoServicio {
    return {
      activo: true,
      orden: 99,
      tiempoMinimoMin: 15,
      tiempoMaximoMin: 60,
      tiempoMaximoIncidenteMin: 60,
    };
  }

  private tieneError(res: any): boolean {
    if (res?.codigoError) {
      this.avisarError(res.mensajeError || "Ocurrió un error en Incidencias Hosting.");
      return true;
    }
    this.errorCarga = "";
    return false;
  }

  private mostrarError(e: any, fallback: string): void {
    this.avisarError(this.motivoError(e) || fallback);
  }

  /**
   * Motivo legible de una falla. Un HttpErrorResponse trae en `message` la URL, que no se muestra;
   * solo se usa el cuerpo. Un Error simple viene de sinSelloDeError con el motivo de la validación de negocio.
   */
  private motivoError(e: any): string {
    if (e instanceof HttpErrorResponse) {
      return e.error?.mensajeError || (typeof e.error?.message === "string" ? e.error.message : "");
    }
    return e instanceof Error ? e.message : "";
  }

  /** Además del aviso en la página, se muestra uno flotante porque los modales tapan el de la página. */
  private avisarError(mensaje: string): void {
    this.errorCarga = mensaje;
    this.errorEmergente = mensaje;
    this.exitoTemporal = "";
  }

  cerrarErrorEmergente(): void {
    this.errorEmergente = "";
  }
}
